import { useSearch } from '@tanstack/react-router';
import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import {
  TrendingInfluencersFilter,
  TrendingInfluencersSearchFilterSchemaType,
  TrendingInfluencersTabType
} from '@anytag/shared-organisms';
import { Header } from '@anytag/shared-molecules';
import { TrendingInstagramInfluencers } from './TrendingInstagramInfluencers';
import { TrendingFacebookInfluencers } from './TrendingFacebookInfluencers';
import { TrendingYoutubeInfluencers } from './TrendingYoutubeInfluencers';

export const TrendingInfluencers = () => {
  useUpdateDocumentTitle({ title: 'documentTitle.Trending Influencers', appHeader: 'appHeader.Trending Influencers' });
  const { filter } = useSearch({
    from: '/_private-routes/trending/influencers'
  }) satisfies TrendingInfluencersSearchFilterSchemaType;

  return (
    <div>
      <Header />
      <TrendingInfluencersFilter />
      {filter.tab === TrendingInfluencersTabType.FACEBOOK ? (
        <TrendingFacebookInfluencers />
      ) : filter.tab === TrendingInfluencersTabType.YOUTUBE ? (
        <TrendingYoutubeInfluencers />
      ) : (
        <TrendingInstagramInfluencers />
      )}
    </div>
  );
};
